// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3EQBRv7MgHSqCe86qR9n7A{height:100%;display:flex;flex-direction:column}._2z5m9iG2hiBwpbeZR8M8o_{padding:.35714rem;height:100%}._3xTPakqzojapm_mLEevexc{background:#fff;padding-top:.5rem}._179dig4ySiK_4EXHqe3bH6{margin:1.42857rem auto;text-align:center;display:inline-flex;justify-content:center;width:100%}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cheerListTab": "_3EQBRv7MgHSqCe86qR9n7A",
	"cheerListTab__content": "_2z5m9iG2hiBwpbeZR8M8o_",
	"cheerListTab__bottomBar": "_3xTPakqzojapm_mLEevexc",
	"cheerListTab__warningInfo": "_179dig4ySiK_4EXHqe3bH6"
};
export default ___CSS_LOADER_EXPORT___;
